// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"eacc1b9df7a37452222b","339":"1eaa6e9772e44a703881"}[chunkId] + ".js";
};